export const LOAD_STATE_TRANSITIONS_STARTED = "LOAD_STATE_TRANSITIONS_STARTED";
export const LOAD_STATE_TRANSITIONS_SUCCESS = "LOAD_STATE_TRANSITIONS_SUCCESS";
